import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as CheckIcon } from '../assets/icons/check.svg';
import { ReactComponent as AlertCircleIcon } from '../assets/icons/alert-circle.svg';
import { ReactComponent as InfoIcon } from '../assets/icons/info.svg';
import { ReactComponent as XIcon } from '../assets/icons/x.svg';

const ICON_BY_TYPE = {
  success: CheckIcon,
  error: AlertCircleIcon,
  info: InfoIcon,
};

/**
 * Toast del design system v2. No reemplaza a components/Toast.js (usado por el
 * hook useToast en Vault.js/legacy): es el componente para las pantallas nuevas.
 * type: 'success' | 'error' | 'info'.
 */
function Toast({ type = 'info', message, onClose, duration = 4000 }) {
  const { t } = useTranslation();
  useEffect(() => {
    if (!duration) return undefined;
    const timer = setTimeout(() => onClose?.(), duration);
    return () => clearTimeout(timer);
  }, [duration, onClose]);

  const Icon = ICON_BY_TYPE[type] || InfoIcon;

  return (
    <div className={`sgc-toast sgc-toast--${type}`} role="status">
      <Icon width={18} height={18} aria-hidden="true" />
      <span className="sgc-toast__message">{message}</span>
      {onClose && (
        <button type="button" className="sgc-toast__close" onClick={onClose} aria-label={t('common.close')}>
          <XIcon width={14} height={14} aria-hidden="true" />
        </button>
      )}
    </div>
  );
}

export default Toast;
